import * as Yup from 'yup';

// Defaults
export const formValues = {
    country: "Slovensko",
    companyName: "",
    contact: "",
    email: "",
    password: "",
}

export const validation = (originalEmail) => (
    Yup.object({
        companyName: Yup.string()
            .required('Názov je povinný.')
            .min(2, 'Minimálny počet znakov je 2.')
            .max(50, 'Maximálny počet znakov je 50.'),
        contact: Yup.string()
            .matches(/\+421[0-9]{9}/, 'Telefónne číslo nie je vo formáte slovenského čísla.')
            .min(13, 'Minimálny počet znakov je 13.')
            .max(13, 'Maximálny počet znakov je 13.')
            .required('Telefónne číslo je povinné'),
        email: Yup.string()
            .email('Nesprávny formát e-mailu.')
            .min(5, 'Minimálny počet znakov je 5.')
            .max(40, 'Maximálny počet znakov je 40.')
            .required('E-mail je povinný.'),
        password: Yup.string()
            .when('email', {
                is: (email) => originalEmail !== undefined && email !== originalEmail,
                then: (schema) => schema.required('Pre zmenu e-mailu je potrebné zadať heslo.'),
                otherwise: (schema) => schema
            }),
        responsiblePerson: Yup.string()
            .required('Zodpovedná osoba je povinná')
            .min(3, 'Minimálny počet znakov je 3.')
            .max(150, 'Maximálny počet znakov je 150.'),
       address: Yup.object({
            street: Yup.string()
                .required('Ulica je povinná.')
                .min(1, 'Minimálny počet znakov je 1.')
                .max(150, 'Maximálny počet znakov je 150.'),
            registrationNumber: Yup.number()
                .typeError('Súpisné číslo musí byť číslo.')
                .max(9999999, 'Neplatná hodnota.')
                .nullable()
                .transform((value, original) => original === '' ? null : value),
            buildingNumber: Yup.string()
                .max(25, 'Maximálny počet znakov je 25.'),
            zip: Yup.string()
                .required('PSČ je povinné.')
                .matches(/^\d*$/, 'PSČ nie je vo formáte slovenského PSČ.')
                .min(5, 'Minimálny počet znakov je 5.')
                .max(5, 'Maximálny počet znakov je 5.'),
            city: Yup.string()
                .required('Mesto je povinné.')
                .min(2, 'Minimálny počet znakov je 2.')
                .max(50, 'Maximálny počet znakov je 50.'),
            country: Yup.string()
                .required('Krajina je povinná.'),
        }),
    })
);
